<template>
  <div class="page-cont">
    <h1 class="page-title">申请中设备</h1>
    
    <div class="device-container">
      <div v-if="applicationList.length === 0" class="no-data">
        暂无申请数据
      </div>
      
      <div class="device-card" v-for="item in applicationList" :key="item.id">
        <div class="device-icon">
          <i class="el-icon-monitor"></i>
        </div>
        <div class="device-info">
          <h3 class="device-name" :title="item.device_name">{{ item.device_name }}</h3>
          <div class="info-item">
            <span class="label">ID:</span>
            <span class="value">{{ item.id }}</span>
          </div>
          <div class="info-item">
            <span class="label">Hash:</span>
            <el-tooltip :content="item.device_hash_id" placement="top">
              <span class="value hash-id">{{ item.device_hash_id }}</span>
            </el-tooltip>
          </div>
          <div class="info-item">
            <span class="label">申请时间:</span>
            <span class="value">{{ formatDate(item.create_time) }}</span>
          </div>
        </div>
        <div class="device-actions">
          <el-button
            size="small"
            type="success"
            @click="handleApprove(item)">批准</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(item)">删除</el-button>
        </div>
      </div>
    </div>

    <!-- 批准对话框 -->
    <el-dialog title="批准设备" :visible.sync="approveDialogVisible" width="30%">
      <el-form :model="approveForm" label-width="100px">
        <el-form-item label="设备哈希ID">
          <el-input v-model="approveForm.deviceHashId" disabled></el-input>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker
            v-model="approveForm.expireTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmApprove">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EquipmentUnderApplication',
  data() {
    return {
      applicationList: [],
      approveDialogVisible: false,
      approveForm: {
        deviceHashId: '',
        expireTime: ''
      }
    };
  },
  mounted() {
    this.fetchApplications();
  },
  methods: {
    formatDate(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleString();
    },
    // 格式化日期为 YYYY-MM-DD HH:mm:ss
    formatDateTime(date) {
      if (!date) return '';
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    async fetchApplications() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('未检测到登录凭证，请重新登录');
        this.$router.push('/login');
        return;
      }

      // 使用服务方式的全屏Loading
      const loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const res = await axios.get(`${this.$store.state.ServerAddress}/api/admin/get-application-list`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          this.applicationList = res.data.data;
          this.$message.success(res.data.msg || '查询成功');
        } else {
            if (res.status === 401 || res.data.status === 401) {
                this.$message.error('登录已过期，请重新登录');
                localStorage.removeItem('UserEmail');
                localStorage.removeItem('token');
                this.$router.push('/login');
            } else {
                this.$message.error(res.data.msg || '查询失败');
            }
        }
      } catch (error) {
        console.error('获取申请列表失败:', error);
        if (error.response && error.response.status === 401) {
             this.$message.error('登录已过期，请重新登录');
             localStorage.removeItem('UserEmail');
             localStorage.removeItem('token');
             this.$router.push('/login');
        } else {
             this.$message.error('网络连接失败');
        }
      } finally {
        loadingInstance.close();
      }
    },
    handleApprove(row) {
      this.approveForm.deviceHashId = row.device_hash_id;
      this.approveForm.expireTime = '';
      this.approveDialogVisible = true;
    },
    async confirmApprove() {
      if (!this.approveForm.expireTime) {
        this.$message.warning('请选择到期时间');
        return;
      }

      const token = localStorage.getItem('token');
      const formattedExpireTime = this.formatDateTime(this.approveForm.expireTime);

      try {
        const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/approve-use`, {
          deviceHashId: this.approveForm.deviceHashId,
          expireTime: formattedExpireTime
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          this.$message.success('批准成功');
          this.approveDialogVisible = false;
          this.fetchApplications(); // 刷新列表
        } else {
          this.$message.error(res.data.msg || '批准失败');
        }
      } catch (error) {
        console.error('批准失败:', error);
        this.$message.error('操作失败');
      }
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该设备申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/delete-device`, {
            deviceHashId: row.device_hash_id
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          if (res.data.success) {
            this.$message.success('删除成功');
            this.fetchApplications(); // 刷新列表
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('操作失败');
        }
      }).catch(() => {
        this.$message.info('已取消删除');          
      });
    }
  }
};
</script>

<style scoped>
.page-cont {
  padding: 20px;
  background-color: white;
  min-height: calc(100vh - 20px);
  width: 90vw;
  box-sizing: border-box;
}

.page-title {
  margin-bottom: 20px;
  font-size: 24px;
  color: #303133;
  display: block;
}

.device-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  width: 100%;
}

.no-data {
  width: 100%;
  text-align: center;
  color: #909399;
  padding: 40px;
}

.device-card {
  width: calc((100% - 140px) / 8); /* 8 cards per row with 20px gap */
  min-width: 140px; /* Reduced by 50% from 280px */
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px; /* Reduced padding */
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

@media screen and (max-width: 1600px) {
  .device-card {
    width: calc((100% - 100px) / 6); /* 6 cards per row */
  }
}

@media screen and (max-width: 1200px) {
  .device-card {
    width: calc((100% - 60px) / 4); /* 4 cards per row */
  }
}

@media screen and (max-width: 800px) {
  .device-card {
    width: calc((100% - 20px) / 2); /* 2 cards per row */
  }
}

.device-card:hover {
  transform: translateY(-3px); /* Reduced movement */
  box-shadow: 0 4px 12px 0 rgba(0,0,0,0.2);
}

.device-icon {
  margin-bottom: 8px; /* Reduced margin */
}

.device-icon i {
  font-size: 30px; /* Reduced by 50% from 60px */
  color: #409EFF;
}

.device-info {
  width: 100%;
  margin-bottom: 10px; /* Reduced margin */
}

.device-name {
  margin: 0 0 8px 0; /* Reduced margin */
  font-size: 12px; /* Reduced font size */
  color: #303133;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px; /* Reduced margin */
  font-size: 10px; /* Reduced font size */
}

.label {
  color: #909399;
  width: 40px; /* Reduced width */
  text-align: left;
}

.value {
  color: #606266;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hash-id {
  font-family: monospace;
}

.device-actions {
  display: flex;
  gap: 8px; /* Reduced gap */
  margin-top: auto;
  flex-wrap: wrap; /* Allow wrapping if needed */
  justify-content: center;
}

.device-actions .el-button {
  padding: 5px 10px; /* Smaller buttons */
  font-size: 10px;
}
</style>
